import { Card } from "@repo/ui";
import { Link } from "react-router-dom";

export default function AdminDashboard() {
  document.title = "แผงควบคุมผู้ดูแลระบบ — Lucky News";
  return (
    <div className="space-y-6">
      <h1 className="font-display text-3xl">แผงควบคุมผู้ดูแลระบบ</h1>
      <p className="text-sm text-foreground/70">ยินดีต้อนรับสู่ระบบหลังบ้านของ Lucky News</p>
      <div className="grid md:grid-cols-3 gap-4">
        <Card className="p-4 bg-card/60">
          <div className="font-display text-lg">ข่าวสาร</div>
          <p className="text-sm text-foreground/70">สร้าง/ลบ/จัดการข่าว และหมวดหมู่ข่าวสาร</p>
          <Link to="/admin/news" className="text-primary text-sm mt-2 inline-block">
            ไปที่เมนู
          </Link>
        </Card>
        <Card className="p-4 bg-card/60">
          <div className="font-display text-lg">จดหมายข่าว</div>
          <p className="text-sm text-foreground/70">ดูรายชื่อผู้สมัคร</p>
          <Link to="/admin/newsletter" className="text-primary text-sm mt-2 inline-block">
            ไปที่เมนู
          </Link>
        </Card>
        <Card className="p-4 bg-card/60">
          <div className="font-display text-lg">การตั้งค่า</div>
          <p className="text-sm text-foreground/70">ลิงก์ติดต่อและอื่นๆ</p>
          <Link to="/admin/settings" className="text-primary text-sm mt-2 inline-block">
            ไปที่เมนู
          </Link>
        </Card>
      </div>
    </div>
  );
}
